import { createFileRoute } from "@tanstack/react-router";
import { TagsTab } from "@/components/admin/TagsTab";

export const Route = createFileRoute("/admin/tags")({
  head: () => ({
    meta: [
      { title: "Tags · Admin · INFLOW Marketing" },
      { name: "description", content: "Every tag applied to a new contact when a lead is synced." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl tracking-tight">Tags</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Every tag that gets added to a contact when a new lead comes through the landing page
          survey, plus how many synced contacts carry each one.
        </p>
      </div>
      <TagsTab />
    </div>
  ),
});
